import ReactModal from "react-modal";
import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { P } from "../CommonStyle";
import "./Ces.css";
import Tick from "./images/tick.svg";
import BgR from "./images/popupBg.png";
import TickG from "./images/greenTick.svg";
import ThankyouSubscribeReport from "./ThankyouSubscribeReport";
import { useEffect } from "react";
import { userTrack } from "../Common";
import Image from "next/image";

const PopupWrap = styled.div`
  position: relative;
  min-height: 200px;
  background: #fff;
  margin: 0 auto;
  height: auto !important;
  overflow: hidden !important;
  border-radius: 11px;
  border: none;
  outline: none;
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media screen and (max-width: 767px) {
    width: auto !important;
    padding: 0 15px;
    display: initial;
  }
`;

const BannerLeft = styled.div`
  background-image: url(${BgR.src});
  background-size: cover;
  background-repeat: no-repeat;
  height: 590px;

  @media screen and (max-width: 767px) {
    display: none;
  }
`;
const ContentRWrap = styled.div`
  padding: 0 60px;
  padding-top: 20px;
`;
const ListWrap = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin-top: 35px;
`;
const TickImg = styled.div`
  margin-top: 8px;
`;
const ListContent = styled.div`
  color: #fff;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.4px;
`;
const BannerRight = styled.div`
  padding: 50px 60px;
  text-align: center;
  padding-top: 100px;

  @media screen and (max-width: 767px) {
    padding: 15px 20px;
  }
`;
const ButtonWrapDwn = styled.div`
  margin-top: 70px;
  margin-bottom: 60px;

  @media screen and (max-width: 767px) {
    margin-top: 60px;
  }
`;
const GTickImg = styled.div``;
const DwnldBtn = styled.div`
  background-color: #ff7624;
  border-radius: 10px;
  padding: 11px 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 13px;
  width: 275px;
  margin: 0 auto;
  cursor: pointer;

  &:hover {
    background-color: #cd5900;
  }

  @media screen and (max-width: 767px) {
    width: 240px;
  }
`;
const DwnldBtnTxt = styled.p`
  margin: 0;
  color: #fff;
  font-family: Roboto;
  font-size: 17px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;

  @media screen and (max-width: 767px) {
    font-size: 16px;
  }
`;

export default function SubscribeReportPopup(props) {
  const [isOpen, setIsOpen] = useState(true);
  const [look, setLook] = useState(false);
  useEffect(() => {
    props.type("subscribe");
  }, []);

  const handleClose = () => {
    props.show(false);
    props.setShowSub(false);
  };

  // for view reports below method
  // const report = () => {
  //   userTrack(
  //     `${localStorage.storedEmail}`,
  //     `Clicked on " View CES 2025 Reports" button`,
  //     "2025 Subscribe Form - Popup"
  //   );
  //   window.location.href =
  //     process.env.NEXT_PUBLIC_SERVER_NAME_URL + "/CES2025Reports.html";
  // };

  // for subscribe button
  const report = () => {
    if (props?.setShow) {
      props.setShow(false);
    }
    if (props?.setShowSub) {
      props.setShowSub(false)
    }
    userTrack(
      `${localStorage.storedEmail}`,
      `Clicked on " View CES 2025 Reports" button`,
      "2025 Subscribe Form - Popup"
    );
    props.setOpenFormAgain(true);
    // setLook(true);
  };

  return (
    <div>
      <ReactModal
        isOpen={isOpen}
        onRequestClose={() => handleClose()}
        ariaHideApp={false}
        className="modal-popup-SubPopUp"
      >
        <PopupWrap>
          <div>
            <BannerLeft>
              <ContentRWrap>
                <P
                  text="Ideapoke CES 2024"
                  color="#fff"
                  fontSize="32px"
                  fontWeight="700"
                  letterSpacing="0.4px"
                ></P>
                <P
                  text="Trends & Innovations report"
                  color="#fff"
                  fontSize="24px"
                  fontWeight="700"
                  letterSpacing="0.4px"
                ></P>
                <div>
                  <ListWrap>
                    <TickImg>
                      <Image src={Tick} alt="Tick" />
                    </TickImg>
                    <ListContent>
                      Innovations that created buzz in 2024
                    </ListContent>
                  </ListWrap>
                  <ListWrap>
                    <TickImg>
                      <Image src={Tick} alt="Tick" />
                    </TickImg>
                    <ListContent>Companies that headlined the show</ListContent>
                  </ListWrap>
                  <ListWrap>
                    <TickImg>
                      <Image src={Tick} alt="Tick" />
                    </TickImg>
                    <ListContent>
                      Impact of these Tech Trends in your area of interest
                    </ListContent>
                  </ListWrap>
                  {/* <ListWrap>
                    <TickImg>
                      <Image src={Tick} alt="Tick" />
                    </TickImg>
                    <ListContent>
                      Spot potential partners, customers, investment
                      opportunities
                    </ListContent>
                  </ListWrap> */}
                </div>
              </ContentRWrap>
            </BannerLeft>
          </div>
          <div style={{ position: "relative" }}>
            <div className="closePopup" onClick={() => handleClose()}>
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.01689 1.01689C1.34785 0.685932 1.79673 0.5 2.26478 0.5C2.73283 0.5 3.18171 0.685932 3.51267 1.01689L11 8.50422L18.4873 1.01689C18.8183 0.685932 19.2672 0.5 19.7352 0.5C20.2033 0.5 20.6521 0.685932 20.9831 1.01689C21.3141 1.34785 21.5 1.79673 21.5 2.26478C21.5 2.73283 21.3141 3.18171 20.9831 3.51267L13.4958 11L20.9831 18.4873C21.3141 18.8183 21.5 19.2672 21.5 19.7352C21.5 20.2033 21.3141 20.6521 20.9831 20.9831C20.6521 21.3141 20.2033 21.5 19.7352 21.5C19.2672 21.5 18.8183 21.3141 18.4873 20.9831L11 13.4958L3.51267 20.9831C3.18171 21.3141 2.73283 21.5 2.26478 21.5C1.79673 21.5 1.34785 21.3141 1.01689 20.9831C0.685931 20.6521 0.5 20.2033 0.5 19.7352C0.5 19.2672 0.685931 18.8183 1.01689 18.4873L8.50422 11L1.01689 3.51267C0.685931 3.18171 0.5 2.73283 0.5 2.26478C0.5 1.79673 0.685931 1.34785 1.01689 1.01689Z"
                  fill="#676767"
                />
              </svg>
            </div>
            <BannerRight>
              <GTickImg>
                <Image src={TickG} alt="TickG" />
              </GTickImg>
              <P
                text="Your Ideapoke CES 2024 report has been sent to your email."
                textAlign="center"
                color="#454545"
                fontSize="20px"
                fontWeight="600"
                mobFontSize="18px"
                MobtextAlign="center"
              ></P>
              {/* " Would you like to view Ideapoke CES 2025 reports?" */}
              {/* <P
                text=" Would you like to Subscribe to the CES 2025 report?"
                textAlign="left"
                color="#454545"
                fontSize="20px"
                fontWeight="600"
                mobFontSize="18px"
                MobtextAlign="center"
                marginTop="40px"
                mobMarginTop="40px"
              ></P> */}

              {/* <ButtonWrapDwn onClick={report}>
                <DwnldBtn>
                  <DwnldBtnTxt>View CES 2025 Reports</DwnldBtnTxt>
                </DwnldBtn>
                <DwnldBtn>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="19"
                    height="23"
                    viewBox="0 0 19 23"
                    fill="none"
                  >
                    <path
                      d="M9.29845 22.5767C7.92788 22.5767 6.69701 21.8317 6.2357 20.7228C6.13712 20.4851 6.13692 20.218 6.23514 19.9802C6.33336 19.7424 6.52197 19.5533 6.75953 19.4544C6.99709 19.3556 7.26417 19.3551 7.50211 19.453C7.74004 19.551 7.92935 19.7394 8.02847 19.9768C8.16457 20.3039 8.64445 20.635 9.29845 20.635C9.95245 20.635 10.4323 20.3039 10.5684 19.9768C10.6673 19.7391 10.8567 19.5504 11.0947 19.4522C11.3328 19.3541 11.6 19.3545 11.8378 19.4534C12.0755 19.5523 12.2642 19.7416 12.3624 19.9797C12.4605 20.2177 12.4601 20.485 12.3612 20.7228C11.8999 21.8317 10.669 22.5767 9.29845 22.5767Z"
                      fill="white"
                    />
                    <path
                      d="M9.20379 0C8.5167 0.000856406 7.8493 0.2296 7.30613 0.650399C6.76297 1.0712 6.37473 1.66028 6.20223 2.32537C4.94174 2.90087 3.87281 3.82589 3.12227 4.99067C2.37173 6.15545 1.9711 7.5111 1.9679 8.89674V12.7976L0.731986 13.9528L0.601994 14.0743L0.49761 14.2184C0.215291 14.6048 0.0458088 15.0619 0.00805531 15.5389C-0.0296982 16.0159 0.06576 16.4941 0.28379 16.92C0.516894 17.3703 0.870453 17.7471 1.30507 18.0083C1.73969 18.2695 2.23829 18.4049 2.74533 18.3994H15.852C16.3725 18.4067 16.8843 18.2647 17.3266 17.9901C17.7689 17.7156 18.1233 17.32 18.3478 16.8503C18.5599 16.406 18.6402 15.9102 18.5792 15.4216C18.5182 14.933 18.3184 14.4722 18.0035 14.0936L17.8867 13.951L17.744 13.8343L16.4188 12.7505V8.89674C16.4157 7.5155 16.0176 6.16396 15.2715 5.00153C14.5255 3.8391 13.4625 2.91426 12.2081 2.3361C12.0375 1.66856 11.6497 1.07673 11.1058 0.653796C10.5619 0.230864 9.89278 0.000859516 9.20379 0Z"
                      fill="white"
                    />
                  </svg>
                  <DwnldBtnTxt>Subscribe to 2025 Report</DwnldBtnTxt>
                </DwnldBtn>
              </ButtonWrapDwn> */}
            </BannerRight>
          </div>
        </PopupWrap>
      </ReactModal>
      {look && (
        <ThankyouSubscribeReport
          setLook={setLook}
          loop={props.show}
          shown={props.setShowSub}
        ></ThankyouSubscribeReport>
      )}
    </div>
  );
}
